// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#copy-icon[data-v-2df43aeb] {\n  width: 24px;\n  height: auto;\n}", "",{"version":3,"sources":["webpack://./resources/js/components/BaseMenuCard.vue"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,YAAA;AAAF","sourcesContent":["\n#copy-icon {\n  width: 24px;\n  height: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
